import React from "react";
import "../../../../css/pages/ca_pages/models/dashboard/RecentActivity.css";

const activities = [
    {
        id: 1,
        type: "Invoice Processed",
        message: "12 invoices processed for ABC Pvt Ltd",
        time: "10 mins ago",
        tag: "invoice",
    },
    {
        id: 2,
        type: "Document Request Sent",
        message: "GST documents requested from XYZ Industries",
        time: "1 hour ago",
        tag: "document",
    },
    {
        id: 3,
        type: "Reminder Sent",
        message: "Reminder sent to John Enterprises",
        time: "3 hours ago",
        tag: "reminder",
    },
    {
        id: 4,
        type: "New Client Added",
        message: "Tech Solutions Pvt Ltd added successfully",
        time: "Yesterday",
        tag: "client",
    },
];

const RecentActivity = () => {
    return (
        <div className="caDashPro__activityCard">
            <div className="caDashPro__activityHeader">
                <h3>Recent Activity</h3>
                <span className="caDashPro__activityCount">
                {activities.length} events
                </span>
            </div>

            <div className="caDashPro__activityList">

                {activities.map((item) => (
                    <div key={item.id} className="caDashPro__activityItem">
                        <div className={`caDashPro__activityDot ${item.tag}`} />

                        <div className="caDashPro__activityContent">
                            <p className="caDashPro__activityType">
                                {item.type}
                            </p>

                            <p className="caDashPro__activityMessage">
                                {item.message}
                            </p>
                        </div>

                        <div className="caDashPro__activityTime">
                            {item.time}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RecentActivity;
